import { ShipmentType } from '@/lib/models/shipment/types';

export const TRACKING_STATUS = {
  PENDING: 'pending',
  RESOLVED: 'resolved',
  UNTRACKABLE: 'untrackable',
  NEW: 'new',
} as const;

export const TRACKING_SOURCE = {
  API: 'api',
  APP: 'app',
} as const;

export type TrackingRequestStatus = (typeof TRACKING_STATUS)[keyof typeof TRACKING_STATUS];

interface BaseTrackingRequest {
  id?: string;
  orgId: string;
  createdAt?: string;
  updatedAt?: string;
  lastCheckedAt?: string;
  status: TrackingRequestStatus;
  mblNumber?: string;
  awbNumber?: string;
  containerNumber?: string;
  bookingNumber?: string;
  parcelNumber?: string;
  type: ShipmentType;
  tags?: string[];
  purchaseOrders?: string[];
  skus?: string[];
  oceanLine?: string;
}

interface ApiTrackingRequestModel extends BaseTrackingRequest {
  source: typeof TRACKING_SOURCE.API;
  userId?: never;
  apiKeyId: string;
}

interface AppTrackingRequestModel extends BaseTrackingRequest {
  source: typeof TRACKING_SOURCE.APP;
  userId: string;
  apiKeyId?: never;
}

export type TrackingRequestModel = ApiTrackingRequestModel | AppTrackingRequestModel;

export const isAppTrackingRequest = (request: TrackingRequestModel): request is AppTrackingRequestModel => {
  return request.source === TRACKING_SOURCE.APP;
};

export const isApiTrackingRequest = (request: TrackingRequestModel): request is ApiTrackingRequestModel => {
  return request.source === TRACKING_SOURCE.API;
};
